module.exports = __webpack_public_path__ + "static/media/evernote.8e04f24a.png";